import { Pipe, PipeTransform } from '@angular/core';
import { contains } from 'ramda';

const getSafeValue = (object, key) => {
  const value = object[key];
  return value === undefined ? '' : value;
};

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[] = [], key: string, searchText: string): any[] {
    if (!searchText) return items;
    const pattern = searchText.toLowerCase();
    return items.filter(item =>
      getSafeValue(item, key)
        .toLowerCase()
        .includes(pattern)
    );
  }
}

@Pipe({
  name: 'omit'
})
export class OmitPipe implements PipeTransform {
  transform(items: any[] = [], key: string, unWantedTags: string[] = []): any[] {
    return items.filter(item => !contains(item[key], unWantedTags));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/tag-editor/select-menu/select-menu.pipe.ts